<template>
  <div class="container">
    <div class="index" v-if="!detail.show">
      <div class="title">
        <span>离职人员管理</span>
      </div>
      <div class="query">
        <el-form ref="form" :model="form" label-width="90px"> </el-form>
        <div class="query">
          <el-form ref="form" :inline="true" :model="form" label-width="90px">
            <el-form-item label="">
              <el-input
                v-model="form.courseName"
                clearable
                placeholder="请输入教师姓名"
              />
            </el-form-item>
            <el-form-item label="" >
              <el-button type="primary" size="small" @click="searchFun"
                >搜索</el-button
              >
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="table">
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          border
        >
          <el-table-column
            align="center"
            prop="q"
            label="照片"
            show-overflow-tooltip
          >
          <template slot-scope="scope">
							<img :src="scope.row.q" style="height:42px" alt="">
          </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="w"
            label="教师姓名"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="e"
            label="账号"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="r"
            label="性别"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="t"
            label="国籍"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="y"
            label="聘用方式"
            show-overflow-tooltip
          >
          </el-table-column>
          <!-- <el-table-column
            align="center"
            prop="u"
            label="联系方式"
            show-overflow-tooltip
          >
          </el-table-column> -->
          <el-table-column
            align="center"
            prop="i"
            label="职业证书"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="o"
            label="教育部备案状态"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="p"
            label="账号状态"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column width="100" label="操作" fixed="right" align="center">
            <template slot-scope="scope">
              <el-button type="text" style="color: red" @click="toDetail(scope)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!--分页组件-->
      <el-pagination
        background
        :current-page="page.pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="page.pageSize"
        :total="page.totalPage"
        layout="total,prev, pager, next,jumper,sizes"
        @size-change="sizeChangeHandle"
        @current-change="currentChangeHandle"
      ></el-pagination>
    </div>
    <!-- <Detail :info="detail.info" v-if="detail.show" @to-index="toIndex"></Detail> -->
  </div>
</template>

<script>
import dayjs from "dayjs";
import api from "@/api/wisdomSchool/index";
// import store from '@/store';
export default {
  //   components: {
  //     Detail: () => import("./details.vue"),
  //   },
  data() {
    return {
      form: {
        schoolYearSemester: "",
        extOrgName: "",
        courseName: "",
        startDate: "",
        endDate: "",
        selectData: "",
      },
      semesterList: [],
      semesterArr: JSON.parse(sessionStorage.getItem("semesterList")) || [],
      page: {
        pageNum: 1,
        pageSize: 10,
        totalPage: 10,
      },

      info: "", // 出库单页面参数
      tableData: [
        // {q:require('./img/user_03.png'),w:"习华伊",  e:"sd****8255",  r:"男",    t:"中国",  y:"全职",  u:"155****3164", i:"教师资格证", o:"已备案", p:"正常", },
        // {q:require('./img/teacher.png'),w:"庄萍雅",  e:"aj****3421",  r:"女",    t:"中国",  y:"全职",  u:"155****3177", i:"教师资格证", o:"已备案", p:"正常", },
        // {q:require('./img/user_02.png'),w:"杨萍蓓",  e:"sd****8227",  r:"女",    t:"中国",  y:"全职",  u:"155****3176", i:"教师资格证", o:"已备案", p:"已锁定", },
        // {q:require('./img/teacher.png'),w:"严姣婷",  e:"aj****3421",  r:"女",    t:"中国",  y:"全职",  u:"155****3175", i:"教师资格证", o:"已备案", p:"正常", },
        // {q:require('./img/user_03.png'),w:"明环凯",  e:"sd****8226",  r:"男",    t:"中国",  y:"全职",  u:"155****3174", i:"教师资格证", o:"已备案", p:"已锁定", },
        // {q:require('./img/teacher.png'),w:"闫媛娣",  e:"aj****3425",  r:"女",    t:"中国",  y:"全职",  u:"155****3173", i:"教师资格证", o:"已备案", p:"正常", },
        // {q:require('./img/user_02.png'),w:"寿歌姣",  e:"sd****8228",  r:"女",    t:"中国",  y:"全职",  u:"155****3172", i:"教师资格证", o:"已备案", p:"已锁定", },
        // {q:require('./img/user_03.png'),w:"满佳青",  e:"sd****8999",  r:"男",    t:"中国",  y:"全职",  u:"155****3574", i:"教师资格证", o:"已备案", p:"正常", },
      ],
      currentPage: 4,
      detail: {
        info: {},
        show: false,
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
    };
  },
  mounted() {},
  created() {
    if (this.semesterArr.length > 0) {
      this.semesterList = this.semesterArr.map((v) => ({
        label: v.schoolYear + "年度" + (v.semester === 1 ? "上学期" : "下学期"),
        value: v.schoolYear + "_" + v.semester,
        id: v.id,
      }));
    }
    console.log("获取学年学期数据--", this.semesterList);
    // this.getDataList();
  },
  methods: {
    async getDataList() {
      if (this.form.selectData == "" || this.form.selectData == null) {
        this.form.startDate = "";
        this.form.endDate = "";
      }
      let params = {
        schoolYearSemester: this.form.schoolYearSemester,
        startDate: this.form.startDate,
        endDate: this.form.endDate,
        teacherId: "", 
        courseName: this.form.courseName,
        extOrgName: this.form.extOrgName,
        orgId: sessionStorage.getItem("orgId"),
        platformCode: sessionStorage.getItem("platformCode"),
        page: this.page.pageNum,
        limit: this.page.pageSize,
      };
      var { data, code } = await api.teacherCourseAttendance(params);
      console.log("获取考勤列表数据---", data);
      if (code == "0") {
        this.tableData = data.list;
        this.page.totalPage = data.total;
      }
    },
    searchFun() {
      this.page.pageNum = 1;
      this.getDataList();
    },
    sizeChangeHandle(val) {
      this.tableData = [];
      this.page.pageSize = val;
      this.getDataList();
    },

    currentChangeHandle(val) {
      this.tableData = [];
      this.page.pageNum = val;
      this.getDataList();
    },
    toDetail(scope) {
    //   console.log(scope);
    //   this.detail.info = scope.row;
    //   this.detail.show = true;
    },
    toIndex() {
      this.detail.show = false;
    },
  },
};
</script>
<style scoped>
.el-range-editor {
  width: 120%;
}
.el-range-editor >>> .el-range-separator {
  width: 8%;
}
::v-deep .el-form .el-input__inner {
  width: 170px;
  height: 32px;
  border-radius: 3px;
  background: #fff;
  border: 1px solid #ddd;
}

::v-deep .el-table__header tr th {
  background: #f7f7f7;
  box-shadow: 0px 1px 0px #eaeaea;
}

::v-deep .el-date-editor .el-range-separator {
  line-height: 22px;
}
</style>

<style lang="less" scoped>
.container {
  width: 100%;
  height: 100%;
  padding: 0 0 2% 2%;
}
.query {
  position: relative;
  margin-bottom: 2%;
}
.searchBtn {
  position: absolute;
  top: 50%;
  right: 5%;
}
.el-pagination {
  margin: 20px 0;
  padding-bottom: 30px;
  text-align: center;
}
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.title {
  height: 50px;
  line-height: 50px;
  border-bottom: 1px solid #eaeaea;
  margin-bottom: 10px;
  span {
    font-family: "PingFang SC Bold";
    font-weight: bold;
    font-size: 20px;
    text-align: left;
    color: #000;
  }
}
</style>
